import React from 'react';
import icon from '../../../../../../assets/icons/charts/zoomAndFilter/icon_temporal_overview.svg';
import SVG from "react-inlinesvg";

const IconTemporalOverviewChart = () => (
    <SVG src={icon} height={40} style = {{ marginTop: 10}} />
);
export default IconTemporalOverviewChart;